module.exports = __webpack_public_path__ + "static/media/Inspiron7.1819fa9f.png";